import { Colors, Fonts } from '../../../shared/theme/';
import styleText from '../../../shared/components/rbh-text/styles';
import metrics from '../../../shared/theme/metrics';
import fonts from '../../../shared/theme/fonts';

export default {
  defaultContent: {} as React.CSSProperties,
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-end',
    paddingBottom: metrics.base * 2,
    height: '56px'
  } as React.CSSProperties,
  headerText: {} as React.CSSProperties,
  icon: {
    color: Colors.lightPurple,
    fontSize: '18px',
    cursor: 'pointer'
  } as React.CSSProperties,
  iconImage: {
    marginRight: '8px',
    marginTop: '-4px',
    width: '24px',
    height: '24px',
    cursor: 'pointer'
  } as React.CSSProperties,
  editWrapper: {
    backgroundColor: Colors.white,
    padding: 40,
  } as React.CSSProperties,
  tableWrapper: {
    backgroundColor: Colors.white,
    padding: 20,
  } as React.CSSProperties,
  menu: {
    fontFamily: 'Kanit-Regular'
  },
  selectedMenuItem: {
    backgroundColor: '#FCF4FA'
  },
  imageBox: {
    verticalAlign: 'top',
    display: 'inline-block',
    backgroundColor: '#F8F8F8',
    border: '1px solid #D9D9D9',
    borderRadius: '4px',
    height: '64px',
    width: '64px'
  },
  image: {
    borderRadius: '4px',
    height: '100%',
    width: '100%'
  },
  menuNameBox: {
    marginLeft: '12px',
    display: 'inline-block',
    width: 'calc(100% - 76px)',
    menuNameText: {
      fontFamily: Fonts.type.KanitRegular,
      fontSize: Fonts.size.text12
    },
    menuNameENText: {
      fontFamily: Fonts.type.KanitRegular,
      fontSize: Fonts.size.text12,
      color: Colors.font.primary.darkGray,
    }
  },
  subTitleText: {
    ...styleText.textRegular14,
    color: Colors.font.primary.darkGray,
    marginBottom: metrics.base * 2
  },
  emptyWrapper: {
    textAlign: 'center'
  } as React.CSSProperties,
  qaDescBox: {
    paddingBottom: metrics.baseMargin + 4,
    paddingTop: metrics.baseMargin / 4
  },
  qaDesc: {
    ...fonts.style.textHeaderKanitRegular14,
    color: Colors.font.primary.darkGray,
  },
  bannerBox: {
    paddingBottom: metrics.baseMargin + 4,
  },
  banner: {
    border: '1px solid #FFA39E',
    backgroundColor: Colors.tagPalered
  },
  messageQc: {
    ...fonts.style.textHeaderKanitRegular14,
    color: Colors.font.messaging.errorRed,
  },
  qcRejectReasons: {
    ...fonts.style.textHeaderKanitRegular14,
    color: Colors.font.messaging.errorRed,
    whiteSpace: 'pre-wrap'
  },
  qcRejectReasonsBox: {
    paddingBottom: metrics.baseMargin / 2,
    paddingTop: metrics.baseMargin / 2,
  }
};
